import React, {Component} from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CourierDeliveryInstructionsForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelSetDeliveryInstructions} from "../../actions/ShippingApiActions";
import {fromJS, Map} from "immutable";
import {validateMaxLength} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validateMaxLength(errors, values, "instructions", 100);
  return errors.toJS();
}

class SetCourierDeliveryInstructionsFormContainer extends Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = {
      orderId: this.props.orderId,
      instructions: values.get("instructions", "").trim()
    }
    return this.props.setCourierDeliveryInstructions(updatedValues)
      .then((response) => {
        if (response.data.setCourierDeliveryInstructions.errors.length <= 0) {
          this.props.cancelSetDeliveryInstructions();
        } else {
          let errors = createValidationErrors(response.data.setCourierDeliveryInstructions.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelSetDeliveryInstructions();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let info = fromJS(data.shippingOrder);
    let initialValues = fromJS({
      instructions: info.get("courierDeliveryInstructions", "")
    })      
    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}

const GET_DELIVERY_INSTRUCTIONS = gql`
  query shippingOrderDeliveryInstructions($orderId:ID!) {
    shippingOrder(orderId:$orderId) {
      orderId
      courierDeliveryInstructions
    }
  }
`;

const SET_DELIVERY_INSTRUCTIONS = gql`
  mutation setCourierDeliveryInstructions($data: ShippingCourierDeliveryInstructionsInput!) {
    setCourierDeliveryInstructions(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(GET_DELIVERY_INSTRUCTIONS, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        orderId: props.orderId
      }      
    })
  }),
  graphql(SET_DELIVERY_INSTRUCTIONS, {
    props: ({ mutate }) => ({
      setCourierDeliveryInstructions: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelSetDeliveryInstructions})(withQuery(SetCourierDeliveryInstructionsFormContainer));